import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IActiveSubscriptionStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IActiveSubscriptionStatsResponse>,
  IPathBaseParam,
  object
>("stores.activeSubscriptionStats");

export const activeSubscriptionStats = {
  ...getApis,
};
